import React, {useState, useEffect} from 'react'
import Layout from '../../components/Layout/Layout'
import axios from 'axios'
import toast from 'react-hot-toast';
import { Button, Modal } from 'react-bootstrap';
import { dateInDMY, hasRight, isAdmin } from '../../Helpers';
import { SERVER_API } from '../../fileWithConstants';
import { useAuth } from '../../context/auth';
import "react-datepicker/dist/react-datepicker.css";
import { Link } from 'react-router-dom';
import { FaExclamationCircle, FaRegCheckCircle } from 'react-icons/fa';
import PoInwarddetails from './PoInwarddetails';
const AllinwardPoList = () => {
    const [auth, setAuth] = useAuth();
    const [userId, setUserId] = useState(auth.user.id);
    const admin_right = isAdmin(auth.user);
    const unique_no_right = hasRight(auth.user, 'po_unique_no');
    const [podata, setPodata]=useState([]);
    const [warehouse, setWarehouse] = useState({});
    const [warehouseData, setWarehouseData] = useState([]);
    const [selectedWarehouse, setSelectedWarehouse] = useState(0);
    const [loading, setLoading] = useState(false);
    const getWareHouse = async()=>{
          try {
              const {data} = await axios.get(`${SERVER_API}/api/v1/supplier/get-warehouse`);
              if(data?.success && data?.wdata.length>0){
                  /* console.log(data) */
                    setWarehouseData(data?.wdata)
                  const warehouseMap = {};
                data?.wdata?.forEach(element => {
                  warehouseMap[element.id] = element.name;
                });
                setWarehouse(warehouseMap);
                  //setWarehouse(data?.wdata);
              }else{
                toast.error('Some thing went wrong while getting Warehouse data.')
              }
          } catch (error) {
              console.log(error)
          }
      }

    const getPoInwarddata = async (houseId = 0) => {
        try {
                setLoading(true); // Start loading
                const { data } = await axios.get(`${SERVER_API}/api/v1/supplier/get-all-inw-po-data`, {
                params: { warehouse: houseId }
                });
                if (data?.success && data?.podata.length > 0) {
                setPodata(data?.podata);
                } else {
                toast.error('Something went wrong while getting PO data.');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false); // Always stop loading
            }
        };


    const handleWarehouseChange = async(houseId)=>{
         setSelectedWarehouse(houseId);
        setLoading(true); // Start loading
        await getPoInwarddata(houseId);
        setLoading(false); // Stop loading
    }

useEffect(()=>{
            getPoInwarddata();
            getWareHouse();
        },[])

  return (
    <Layout title={'Po Inward List Page'}>
        <div className='container'>
            <div className='justify-content-center'>
                    <h1 className='page-title text-center'>All PO Intake List</h1> 
                    <div className="row">
                        <div className="col-12 d-flex justify-content-center">
                             <div className="col-md-3" style={{ marginBottom: '10px' }}>
                                <select
                                    className="form-control"
                                    required
                                    name="warehouse"
                                    value={selectedWarehouse} // <-- use a state variable here
                                    onChange={(e) => {handleWarehouseChange(e.target.value)}} // <-- capture change
                                    >
                                    <option value="">--Select--</option>
                                    {warehouseData?.map((house) => (
                                        <option key={house.id} value={house.id}>
                                        {house.name}
                                        </option>
                                    ))}
                                    </select>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                    <div className="col-md-12">
                    <div className='table-box'>
                    {loading ? (
                    <div className="text-center my-3">
                        <span className="spinner-border text-dark" role="status" aria-hidden="true"></span>
                        <span className="ms-2">Loading PO data...</span>
                    </div>
                    ) : (
                        <table className="table table-responsive table-hover table-sticky">
                            <thead>
                                <tr className='align-item'>
                                    <th scope="col">#</th>
                                    <th scope="col" className='text-center'>PO No.</th>
                                    <th scope="col" className='text-center'>Fabric</th>
                                    <th scope="col" className='text-center'>Fabric(Supplier)</th>
                                    <th scope="col" className='text-center'>Warehouse</th>
                                    <th scope="col" className='text-center'>Than No.</th>
                                    <th scope="col" className='text-center'>Quantity</th>
                                    <th scope="col" className='text-center'>Unit</th>
                                    <th scope="col" className='text-center'>Price</th>
                                    <th scope="col" className='text-center'>Dis %</th>
                                    <th scope="col" className='text-center'>Amount INR</th>
                                  
                                    {(unique_no_right || admin_right) && (
                                          <th scope="col" className='text-center'>Unique No.</th>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {podata?.map((po, index)=>(
                                    <tr key={index}>
                                        <td>{index+1}</td>
                                         <td>{po.po_num}</td>
                                        <td className='text-start'>{po.name}</td>
                                        <td className='text-start'>{po.supplierfbname}</td>
                                        <td className='text-start'>{warehouse[po.warehouse]}</td>
                                        <td>{po.than_no}</td>
                                        <td>{po.inw_qty}</td>
                                        <td>{po.unit}</td>
                                        <td>{po.inw_price}</td>
                                        <td>{po.inw_discount}</td>
                                        <td>{po.inw_amount}</td>
                                        {(unique_no_right || admin_right) && (
                                        <td>{po.unique_no}</td>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}


                        
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
  )
}

export default AllinwardPoList
